export default function transformSelectedChartType(statTypes) {
  if (!Array.isArray(statTypes)) return [];
  let selectedArray = [];
  statTypes.forEach(item => {
    if (item.is_selected) {
      selectedArray.push(item.value);
      if (item.children) {
        selectedArray = selectedArray.concat(
          transformSelectedChartType(item.children),
        );
      }
    }
  });
  return selectedArray;
}
